import type { IconTextItem } from 'src/app/types';

import { ListContainer, ListItemContainer, ListItemImage, ListItemText } from './styles';

interface IconListWithTextProps {
  items: IconTextItem[];
}

export const IconListWithText = ({ items }: IconListWithTextProps) => {
  return (
    <ListContainer>
      {items.map(({ text, iconSource }) => (
        <ListItemContainer>
          {iconSource && <ListItemImage src={iconSource} />}
          <ListItemText>{text}</ListItemText>
        </ListItemContainer>
      ))}
    </ListContainer>
  );
};
